export const cleanFormData = (formData: any): any => {
  const { title, _creativityType, ...config } = formData;
  const { team1, team2, round, date } = config;

  return { team1, team2, round, date };
};
